import * as React from "react";
import { Typography } from "@mui/material";
import Container from "@mui/material/Container";
import { Link } from "react-router-dom";

function Info() {
  return (
<Container className="info" maxWidth="xl">
  <div className="info-content">
    <div className="text-section">
      <Typography className="title" variant="h6">
        IMPORTANT CUSTOMER INFO FOR THOSE ATTENDING EDINBURGH PSYCH FEST
      </Typography>
      <Typography className="text">
        Ahead of Edinburgh Psych Fest this Sunday we wanted to share some
        important information for you to read before the day.
      </Typography>
    </div>

    <div className="text-section">
      <Typography className="title" variant="h6">
        Box Office & Wristband Collection
      </Typography>

      <Typography className="text">
        The box office & wristband collection will be in Summerhall and open
        from 11 am - 9.00 pm. This will be the only place you can collect your
        festival wristband.
      </Typography>

      <Typography className="text">
        The first live band is on at 1 pm so we would suggest arriving as early
        as possible to avoid disappointment.
      </Typography>

      <Typography className="text">
        Wristbands must be collected in person. If you booked as a group please
        arrive together, or send e-tickets directly to your group members, as
        you will not be able to collect wristbands on the behalf of others.
      </Typography>

      <Typography className="text">
        Tickets will be scanned. To avoid delays please ensure that you have
        either a paper copy of your e-ticket or a pdf download ready on your
        smartphone before arriving.
      </Typography>

      <Typography className="text">
        You will not be able to gain entry to any of the venues without
        collecting your festival wristband first.
      </Typography>

      <Typography className="text">
        The festival is Ages 14 + (Under 16's Must Be Accompanied By An Adult)
      </Typography>

      <Typography className="text">
        The EPF After Party at People’s Leisure Club is strictly 18+. 11pm-late.
      </Typography>
    </div>

    <div className="text-section">
      <Typography className="title" variant="h6">
        Stage Times
      </Typography>

      <Typography className="text">
        Stage times & splits can be found on the official festival app,
        download it now via the website{" "}
        <Link
          target="_blank"
          to="https://edinburghpsychfest.com/stage-times"
        >
          here
        </Link>
        .
      </Typography>

      <Typography className="text">
        Please note, venues are strictly first come, first served so please
        arrive as early as you can to see anyone specific. Once a venue reaches
        capacity it will operate a one-in-one out policy. Some venues will stop
        people entering towards the end of a set to allow for crowds to leave
        before the next act.
      </Typography>
    </div>

    <div className="text-section">
      <Typography className="title" variant="h6">
        Usher Hall - Entry Procedure
      </Typography>

      <Typography className="text">
        Usher Hall has three areas: Stalls (Standing), Grand Circle and Upper
        Circle. Each area will have its own clearly signposted entrance and
        queue.
      </Typography>

      <Typography className="text">
        Please choose which area you’d like to be in ahead of time and join the
        relevant queue when you arrive. You’ll be given a Usher Hall wristband
        on entry, which grants access to that area only.
      </Typography>

      <Typography className="text">
        If you opt for the Grand or Upper Circle please use all the seats and
        leave no gaps.
      </Typography>

      <Typography className="text">
        If you leave the venue, you’ll need to return your Usher Hall wristband
        and will be giving up your place in the venue. Previous entry does not
        guarantee re-entry. If you return later, you’ll need to join the
        relevant queue again and entry will be subject to availability at that
        time.
      </Typography>
    </div>

    <div className="text-section">
      <Typography className="title" variant="h6">
        Bag & Camera Policy
      </Typography>

      <Typography className="text">
        Please note there are no facilities for leaving large bags or luggage.
        Large bags, including rucksacks, are not permitted.
      </Typography>

      <Typography className="text">
        If you have to bring a bag – and it’s preferable you don’t – please make
        sure it’s small and no larger than A4.
      </Typography>

      <Typography className="text">
        Audio and video recording cameras are prohibited. Professional cameras
        are not permitted in any venues unless accredited. If your camera has a
        detachable lens you will not be allowed to bring it into the venues.
      </Typography>
    </div>

    <div className="text-section">
      <Typography className="title" variant="h6">
        U24s Ticket
      </Typography>

      <Typography className="text">
        If you have purchased an under 24s ticket, you will need to show a valid
        photo.
      </Typography>

      <Typography className="text">
        I.D = passport, driving license or national I.D card at the box office.
      </Typography>

      <Typography className="text">
        Failure to do so will result in a £10 charge.
      </Typography>

      <Typography className="text">
        DOB must be on or after 1/9/2001
      </Typography>
    </div>

    <div className="text-section">
      <Typography className="title" variant="h6">
        NHS Ticket
      </Typography>

      <Typography className="text">
        If you have purchased a ticket with NHS discount, you will need your NHS
        I.D when collecting your wristband. 1 per person.
      </Typography>

      <Typography className="text">
        Failure to do so will result in a £10 charge at the collection point.
      </Typography>
    </div>

    <div className="text-section">
      <Typography className="title" variant="h6">
        Food Stalls
      </Typography>

      <Typography className="text">
        Food is available on-site in Summerhall’s Courtyard and The Royal Dick
        pub, catering for all dietary requirements. This year's food traders can
        be found{" "}
        <Link target="_blank" to="https://edinburghpsychfest.com/food">
          HERE
        </Link>
        .
      </Typography>
    </div>

    <div className="text-section">
      <Typography className="title" variant="h6">
        Accessibility
      </Typography>

      <Typography className="text">
        Access wristbands will be available for collection at Summerhall's box
        office. For eligibility you need to provide one or more of the following
        to info@edinburghpsychfest.com
      </Typography>

      <Typography className="text">
        Personal Independence Payment (PIP)
      </Typography>

      <Typography className="text">
        Disability Living Allowance (DLA)
      </Typography>

      <Typography className="text">Carer’s Allowance</Typography>

      <Typography className="text">Blue Badge (both sides)</Typography>

      <Typography className="text">
        Blind or partially sighted registration certificates
      </Typography>

      <Typography className="text">Benefit award letters</Typography>

      <Typography className="text">UK Access Card (+1 symbol)</Typography>

      <Typography className="text">
        Letters from medical professionals (GP, occupational therapist, etc.)
      </Typography>

      <Typography className="text">Access wristbands allow</Typography>

      <Typography className="text">
        Entry to venue access areas (if applicable).
      </Typography>

      <Typography className="text">Queue jump.</Typography>

      <Typography className="text">Please note</Typography>

      <Typography className="text">
        Most venues have limited access areas which are available on a
        first-come, first-served basis (same as non-access areas). Entry to
        venues and access areas is subject to capacity.
      </Typography>

      <Typography className="text">
        It’s also worth giving venues a heads-up directly if you have specific
        requirements.
      </Typography>

      <Typography className="text">
        Click{" "}
        <Link
          target="_blank"
          to="https://cultureedinburgh.com/our-venues/usher-hall"
        >
          here
        </Link>{" "}
        for Usher Hall accessibility info.
      </Typography>

      <Typography className="text">
        Click{" "}
        <Link target="_blank" to="https://la-belleangele.com/contact/">
          here
        </Link>{" "}
        for La Belle Angele accessibility info.
      </Typography>

      <Typography className="text">
        Click{" "}
        <Link
          target="_blank"
          to="https://www.thequeenshall.net/your-visit/access-information"
        >
          here
        </Link>{" "}
        for The Queen’s Hall accessibility info.
      </Typography>

      <Typography className="text">
        Click{" "}
        <Link
          target="_blank"
          to="https://www.summerhall.co.uk/about/accessibility/"
        >
          here
        </Link>{" "}
        for Summerhall accessibility info.
      </Typography>

      <Typography className="text">
        Click{" "}
        <Link target="_blank" to="https://www.sneakypetes.co.uk/about/">
          here
        </Link>{" "}
        for Sneaky Pete's accessibility info.
      </Typography>
    </div>

    <div className="text-section">
      <Typography className="title" variant="h6">
        Getting to the Festival
      </Typography>

      <Typography className="text">
        All venues will be accessible by road
      </Typography>

      <Typography className="text">
        Edinburgh Waverley (1.1 miles)
      </Typography>

      <Typography className="text">
        Closest Tram Strop: St Andrews Sq (1.3 miles)
      </Typography>

      <Typography className="text">
        Edinburgh Bus Station (1.8 miles)
      </Typography>

      <Typography className="text">
        South Clerk Street, just behind Summerhall, is served by the following
        buses: 2, 3, 5, 7, 8, 29, 30, 31, 33, 37, 47, 49, N3, N30, N31, N37.
      </Typography>
    </div>

    <div className="text-section">
      <Typography className="text">Enjoy your day!</Typography>
      <Typography className="text">Edinburgh Psych Fest</Typography>
    </div>

    <div className="text-section">
      <br />
      <Typography className="text">
        * Line-up subject to change
      </Typography>
      <Typography className="text">
        ** Venue capacities are based on first come first serve so please arrive
        early for specific acts.
      </Typography>
    </div>

    <div className="text-section">
      <Typography className="title" variant="h6">
        Contact
      </Typography>
      <Typography className="text">info@edinburghpsychfest.com</Typography>
    </div>
  </div>
</Container>
  );
}
export default Info;
